import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { Page } from 'app/interfaces/api/types';
import { PageService } from 'app/services';
import { DomHelper } from 'app/classes/dom-helper/dom-helper';

@Component({
  selector: 'app-stele-page',
  templateUrl: './stele-page.page.html',
  styleUrls: ['./stele-page.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StelePagePage implements OnInit {
  @ViewChild('pageContent', { read: ElementRef, static: false })
  private pageContent: ElementRef;

  public page: Page;
  public id: string;
  public slug: string;
  public didLoad: boolean = false;

  constructor(
    private readonly pageService: PageService,
    private readonly navCtrl: NavController,
    private readonly activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void { }

  ionViewWillEnter(): void {
    this.reset();
  }

  async ionViewDidEnter(): Promise<void> {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.slug = this.activatedRoute.snapshot.paramMap.get('slug');

    if (this.id) {
      this.page = await this.pageService.getByID(this.id);
    } else if (this.slug) {
      this.page = await this.pageService.getBySlug(this.slug);
    }

    DomHelper.whenReady(this.pageContent.nativeElement).then(() => this.didLoad = true);
  }

  public goBack(): void {
    this.navCtrl.back();
  }

  private reset(): void {
    this.didLoad = false;
    this.page = null;
    this.id = null;
    this.slug = null;
  }
}
